import { useState } from 'react';
import { SampleTable } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { IEquipoServicioAdicionales } from '@/shared/interfaces';
import { useEquiposAdicionalesTable } from '@/shared/components/ui/ProspectoAndPreventa/hooks';
import { Button } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export type EquipoAdicionalIconBtnCellModalProps = {
  //preventa?: Omit<IDataPreventa, 'prospecto_data'>;

  equipoAdicional?: IEquipoServicioAdicionales[] | undefined | null;
};

const EquipoAdicionalIconBtnCellModal: React.FC<
  EquipoAdicionalIconBtnCellModalProps
> = ({
  //preventa,
  equipoAdicional
}) => {
    ///* local state -------------------
    const [open, setOpen] = useState(false);

    const { columnsEquiposAdicionalesAgenda } = useEquiposAdicionalesTable({
      showItemPrice: false,
    });

    if (!equipoAdicional?.length) {
      return '—'
    }

    return (
      <>
        <Button
          startIcon={<OpenInNewIcon />}
          color="primary"
          onClick={() => {
            setOpen(true);
          }}
        >VER</Button>

        {/* ----- modal table ----- */}
        <ScrollableDialogProps
          open={open}
          title="Equipos Adicionales"
          minWidth="45%"
          cancelTextBtn="Cerrar"
          onClose={() => {
            setOpen(false);
          }}
          contentNode={
            <>
              {/* <EquipoAdicionalPreventaBooleans preventa={preventa! as any || {}} /> */}

              <SampleTable
                columns={columnsEquiposAdicionalesAgenda}
                data={equipoAdicional || []}
              />
            </>
          }
        />
      </>
    );
  };

export default EquipoAdicionalIconBtnCellModal;
